import React, {useRef} from "react";
import BusinessTabs from "./BusinessTabs";
import CheckCard from "./CheckCard";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FeatureDreamHead from "./FeatureDreamHead";

const ConnecterList = [
    {
        id: 1,
        subTitle: "SaaS",
        logoList: [
            {
                id: 1,
                img: "/img/dreamfactory/logo_fcm.svg",
                logoTit: "FCM"
            },
            {
                id: 2,
                img: "/img/dreamfactory/logo_aws_sns.svg",
                logoTit: "AWS SNS"
            },
            {
                id: 3,
                img: "/img/dreamfactory/logo_okta.svg",
                logoTit: "Okta"
            },
            {
                id: 4,
                img: "/img/dreamfactory/logo_salesforce.svg",
                logoTit: "Salesforce"
            },
        ]
    },
    {
        id: 2,
        subTitle: "SQL",
        logoList: [
            {
                id: 1,
                img: "/img/dreamfactory/logo_oracle.svg",
                logoTit: "Oracle"
            },
            {
                id: 2,
                img: "/img/dreamfactory/logo_mysql.svg",
                logoTit: "MySQL"
            },
            {
                id: 3,
                img: "/img/dreamfactory/logo_maria_db.svg",
                logoTit: "MariaDB"
            },
            {
                id: 4,
                img: "/img/dreamfactory/logo_postgre_sql.svg",
                logoTit: "PostgreSQL"
            },
            {
                id: 5,
                img: "/img/dreamfactory/logo_sap.svg",
                logoTit: "SAP"
            },
        ]
    },
    {
        id: 3,
        subTitle: "Big Data",
        logoList: [
            {
                id: 1,
                img: "/img/dreamfactory/logo_snowflake.svg",
                logoTit: "Snowflake"
            },
            {
                id: 2,
                img: "/img/dreamfactory/logo_hadoop.svg",
                logoTit: "Hadoop"
            },
        ]
    },
    {
        id: 4,
        subTitle: "Email",
        logoList: [
            {
                id: 1,
                img: "/img/dreamfactory/logo_mailgun.svg",
                logoTit: "Mailgun"
            },
            {
                id: 2,
                img: "/img/dreamfactory/logo_smtp.svg",
                logoTit: "SMTP"
            },
            {
                id: 3,
                img: "/img/dreamfactory/logo_mandrill.svg",
                logoTit: "Mandrill"
            },
        ]
    },
    {
        id: 5,
        subTitle: "Logging & Reporting",
        logoList: [
            {
                id: 1,
                img: "/img/dreamfactory/logo_logstash.svg",
                logoTit: "Logstash"
            },
            {
                id: 2,
                img: "/img/dreamfactory/logo_elasticsearch.svg",
                logoTit: "Elasticsearch"
            },
            {
                id: 3,
                img: "/img/dreamfactory/logo_kibana.svg",
                logoTit: "Kibana"
            },
        ]
    },
    {
        id: 6,
        subTitle: "Version control",
        logoList: [
            {
                id: 1,
                img: "/img/dreamfactory/logo_github.svg",
                logoTit: "GitHub"
            },
            {
                id: 2,
                img: "/img/dreamfactory/logo_gitlab.svg",
                logoTit: "GitLab"
            },
            {
                id: 3,
                img: "/img/dreamfactory/logo_bitbucket.svg",
                logoTit: "Bitbucket"
            },
        ]
    },
];

const CheckList_01 = [
    {
        id: 1,
        description: "데이터나 리소스 사용량을 통제할 수 있습니다."
    },
    {
        id: 2,
        description: "서비스, 유저, 엔드포인트 등 유연한 제한조정이 가능합니다."
    },
    {
        id: 3,
        description: "분, 시, 일 단위의 설정이 가능합니다. "
    },
    {
        id: 4,
        description: "HTTP Status Code를 준수합니다. (429)"
    },
];

const CheckList_02 = [
    {
        id: 1,
        description: "읽기전용 API 작성도 가능합니다."
    },
    {
        id: 2,
        description: "포인트 앤 클릭 수준의 UI로 API 접근을 관리합니다."
    },
    {
        id: 3,
        description: "엔드포인트나 방식에 따른 접근 설정을 할 수 있습니다."
    },
];

const CheckList_03 = [
    {
        id: 1,
        description: "ELK스택 통합"
    },
    {
        id: 2,
        description: "로그인 스펙의 정의"
    },
    {
        id: 3,
        description: "Kibana 또는 Grafana를 이용한 리얼타임 트래픽 대시보드"
    },
];

const CheckList_04 = [
    {
        id: 1,
        description: "유니크한 API KEY"
    },
    {
        id: 2,
        description: "기본적인 인증"
    },
    {
        id: 3,
        description: "LDAP이나 Active Directory"
    },
    {
        id: 4,
        description: "SAML 기반 SSO"
    },
    {
        id: 5,
        description: "AD / LDAP 그룹마다의 역할 부여 가능"
    },
];

const LogoStrap_01 = [
    {
        id: 1,
        img: "/img/logo/salesforce_logo.svg"
    },
    {
        id: 2,
        img: "/img/logo/mck_logo.svg"
    },
    {
        id: 3,
        img: "/img/logo/slack_logo.svg"
    },
    {
        id: 4,
        img: "/img/logo/walmart_logo.svg"
    },
    {
        id: 5,
        img: "/img/logo/bhp_logo.svg"
    },
    {
        id: 6,
        img: "/img/logo/infosys_logo.svg"
    },
];

const LogoStrap_02 = [
    {
        id: 1,
        img: "/img/logo/salesforce_logo.svg"
    },
    {
        id: 2,
        img: "/img/logo/mck_logo.svg"
    },
    {
        id: 3,
        img: "/img/logo/slack_logo.svg"
    },
    {
        id: 4,
        img: "/img/logo/walmart_logo.svg"
    },
    {
        id: 5,
        img: "/img/logo/bhp_logo.svg"
    },
    {
        id: 6,
        img: "/img/logo/infosys_logo.svg"
    },
];

const Subject = [
    {
        id: 1,
        title: "프론트엔드\n" +
            "개발자",
        detail_01: "서버쪽 설정을 기다리지 않고 프론트 작업에 집중할 수 있습니다.",
        detail_02: "몇번의 클릭만으로 데이터 소스에 몇분만에 접속할 수 있습니다.",
        detail_03: "간단하면서도 안전 RESTful로 여러개의 데이터에 접근할 수 있습니다.",
        detail_04: "신속하면서도 시규어난 REST API로 프로젝트를 큰 비용없이 수행 가능합니다."
    },
    {
        id: 2,
        title: "백엔드 / API \n" +
            "엔지니어",
        detail_01: "REST API의 불편한 문서작업이 \n" +
            "필요 없습니다.",
        detail_02: "프로세스의 스크립트 로직으로 API 자동생성도 충분히 커스터마이즈 가능합니다.",
        detail_03: "온프레미스와 클라우드 모두 자유자재로 연계할 수 있습니다.",
        detail_04: "OAuth, LDAP, Active Directory 등 기존의 보안을 활용할 수 있기 때문에, 매번 테스트를 수행할 필요가 없습니다."
    },
    {
        id: 3,
        title: "엔터프라이즈\n" +
            "아키텍트",
        detail_01: "온프레미스나 클라우드에서 작업하고 있는 자신의 데이터를 안전하게 관리합니다.",
        detail_02: "기업의 데이터소스를 시큐어 하면서도 확장가능한 REST API화 할 수 있기 때문에 디지털 전환에 적합합니다.",
        detail_03: "레거시의 데이터소스라도 최신의 API 형식으로 변환이 가능하기에, 최신의 앱개발에 활용이 가능합니다",
        detail_04: "매니지드 REST 서비스로서 신뢰할 수 있는 안전한 앱개발을 전사적으로 수행할 수 있습니다."
    },
];

function renderWithLineBreaks(text: string) {
    return text.split("\n").map((line, index) => (
        <React.Fragment key={index}>
            {line}
            <br/>
        </React.Fragment>
    ));
}

const swipePower = (offset: number, velocity: number) => {
    return Math.abs(offset) * velocity;
};

export const wrap = (min: number, max: number, v: number) => {
    const rangeSize = max - min;
    return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};

const FeatureDreamfactory = () => {
    const ref = useRef(null);
    const settings = {
        dots: true,
        autoplay: false,
        Speed: 5000,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        arrows: false
    };

    return (
        <>
            <BusinessTabs current="dreamfactory" />

            <FeatureDreamHead />
            {/* <div className="container mx-auto max-w-6xl space-y-52 p-6 px-8 py-12 lg:max-w-7xl lg:px-12"></div> */}

            <section id="1" className="scroll-mt-below-tabs md:scroll-mt-below-tabs-md">
                <div className="container max-w-full overflow-hidden bg-white px-5 py-section-lg md:flex md:min-h-[calc(100vh-124px)] md:flex-col md:justify-center xl:px-0">
                    <div className="overviewWrap relative m-auto flex max-w-7xl flex-col items-stretch justify-start gap-4 rounded-[15px] py-4 sm:gap-8 sm:px-6 sm:py-6 md:px-8 md:flex-row md:items-end lg:justify-center lg:gap-4">
                        <div className="overviewBox relative mb-3 w-full overflow-hidden bg-white md:h-[33.5rem] md:w-[25%]">
                            <div className="num_box">
                                <h1
                                    className="mb-4 justify-start text-h1 font-bold text-brand"
                                >
                                    About us
                                </h1>
                            </div>
                            <p className="justify-start text-body font-normal text-black">
                                혁신적인 API 매니지먼트 솔루션으로, 고객의
                                디지털 전환과 모더나이제이션을 돕습니다.
                            </p>
                        </div>

                        <div
                            className="overviewBox relative w-full overflow-hidden rounded-2xl bg-white md:h-[467px] md:w-[25%]
                            px-[20px] py-[40px] shadow-md before:absolute before:left-[0]
                            before:top-[0] before:block before:h-[27px] before:w-full before:bg-brand before:content-['']
                        "
                        >
                            <div className="num_box">
                                <h1 className="text-display font-bold text-brand">
                                    1K
                                </h1>
                            </div>
                            <p className="pb-[15px] pt-[30px] text-h3 font-semibold text-black">
                                고객수
                            </p>
                            <p className="text-body font-normal text-black">
                                Fortune 500 기업을 포함 의료, 금융, 통신, 정부,
                                제조업 등 모든 산업분야에서 1 천사 이상의 기업이
                                선택하고 있습니다.
                            </p>
                        </div>

                        <div
                            className="overviewBox relative w-full overflow-hidden rounded-2xl bg-white shadow-md md:h-[467px] md:pb-[80px] md:w-[25%]
                            "
                        >
                            <div className="num_box flex h-[260px] items-end bg-brand px-[20px] py-[22px]">
                                <h1 className="pr-1 text-display font-bold text-[#fff]">
                                    500
                                </h1>
                                <p className="text-h1 font-bold text-[#fff]">
                                    M+
                                </p>
                            </div>
                            <div className="px-[20px] py-[20px]">
                            <p className="text-h3 font-semibold text-black pb-[15px]">
                                하루 리퀘스트 건수
                            </p>
                            <p className="text-body font-normal text-black">
                                DreamFactory를 활용한 고객의 API트래픽은 매일
                                급속하게 증가하고 있습니다.
                            </p>
                            </div>
                        </div>

                        <div
                            className="overviewBox relative flex w-full flex-col justify-end overflow-hidden md:h-[467px] md:w-[25%]
                            rounded-2xl bg-brand px-[20px] py-[22px] shadow-md"
                        >
                            <div className="num_box">
                                <h1 className="text-display font-bold text-[#fff]">
                                    0
                                </h1>
                            </div>
                            <p className="pb-[15px] pt-[30px] text-h3 font-bold text-[#fff]">
                                (Zero Coding) <br/> Instant API
                            </p>
                            <p className="text-body font-normal text-[#fff]">
                                도입이 매우 간단합니다. API의 디자인부터, 보안,
                                문서, 연결까지 수작업이 불필요해집니다.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="container m-auto max-w-6xl overflow-hidden bg-white px-5 pb-section-lg xl:px-0">
                    <p className="mx-auto mt-4 max-w-6xl text-h3 font-bold text-brand">
                        Connecter
                    </p>
                    <h1 className="mt-4 mx-auto max-w-6xl text-h1 font-bold text-gray-900">
                        데이터 소스가 흩어져 있더라도 걱정하지 마세요.
                    </h1>
                    <p className="m-auto mt-4 max-w-6xl break-keep text-body font-normal tracking-tight text-gray-500">
                        DreamFactory는 인기 있는 SQL과 NoSQL을 중심으로 20가지
                        이상의 데이터베이스 커넥터를 지원하고 있습니다.
                        <br className="hidden sm:block" />
                        Salesforce, Okta 같은 외부 SaaS 시스템과 Snowflake
                        기반의 빅데이터 플랫폼까지 다양한 기술 스택을 하나로
                        연결하고,
                        <br className="hidden sm:block" />
                        필요한 모든 기능을 API로 자동화합니다.
                    </p>

                    <div className="connecter_wrap mt-14 flex flex-row flex-wrap items-start justify-between gap-x-1 gap-y-14">
                        {ConnecterList.map(list => (
                            <div
                                key={list.id}
                                className="connecter_box w-[32%]"
                            >
                                <p
                                    className="mb-3 flex h-12 items-end justify-start text-h3 font-medium
                                text-zinc-800 lg:h-auto"
                                >
                                    {list.subTitle}
                                </p>
                                <div
                                    className="rounded-[10px] bg-gray-50 p-8 outline outline-1
                                outline-offset-[-1px] outline-gray-200"
                                >
                                    <ul className="flex flex-wrap content-start items-start justify-center gap-x-14 gap-y-12">
                                        {list.logoList.map(logo => (
                                            <li
                                                key={logo.id}
                                                className="flex w-[80%] flex-col items-center gap-6 lg:w-[20%]"
                                            >
                                                <img
                                                    src={logo.img}
                                                    alt=""
                                                    className="flex h-16 w-16 items-center justify-center"
                                                />
                                                <span
                                                    className="justify-start whitespace-nowrap text-center text-lead
                                                font-normal text-zinc-500"
                                                >
                                                    {logo.logoTit}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="container max-w-full overflow-hidden bg-[#F9FAFB] px-5 py-section-lg xl:px-0">
                    <div
                        className="relative m-auto grid max-w-6xl grid-cols-1 gap-4
                    rounded-[15px] py-4 sm:gap-8 sm:py-6 md:grid-cols-2 lg:gap-4"
                    >
                        <CheckCard
                            title="유연한 컨트롤"
                            icon="/img/dreamfactory/Control_icon.svg"
                            items={CheckList_01}
                        />
                        <CheckCard
                            title="포괄적인 권한관리"
                            icon="/img/dreamfactory/Manage_icon.svg"
                            items={CheckList_02}
                        />
                        <CheckCard
                            title="로그관리 및 감사대응"
                            icon="/img/dreamfactory/Dashboard_icon.svg"
                            items={CheckList_03}
                        />
                        <CheckCard
                            title="다양한 인증수단"
                            icon="/img/dreamfactory/Checking_icon.svg"
                            items={CheckList_04}
                        />
                    </div>
                </div>

                <div className="container max-w-full overflow-hidden px-5 py-section-lg xl:px-0">
                    <div
                        className="logoStrap relative m-auto flex max-w-7xl flex-col
                    items-center justify-start gap-6 rounded-[15px] sm:py-6"
                    >
                        <h2 className="text-center text-h1 font-semibold text-brand">
                            Fortune 500 기업으로부터
                            <br />
                            선택받고 있습니다.
                        </h2>

                        <p className="text-balance text-center text-lead font-normal text-[#969696] sm:text-[24px]">
                            업종을 불문하고 다양한 기업에서 <span className="font-medium">DreamFactory</span>를
                            도입하고 있습니다.
                            <br />
                            제조업, 정부/공공기관, 의료, 금융, 기술분야 등
                        </p>

                        <div className="logoWrap mt-8 w-full">
                            <div className="logoBox mb-6 flex flex-col justify-evenly gap-4 md:flex-row">
                                {LogoStrap_01.map(list => (
                                    <div
                                        key={list.id}
                                        className="flex h-24 items-center justify-center
                                                    rounded-lg border-[0.52px] border-[#f1f2f6]
                                                    bg-white/30 p-6 shadow-subtle md:w-60"
                                    >
                                        <img
                                            src={list.img}
                                            className="h-auto object-contain md:block"
                                            alt=""
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container max-w-full overflow-hidden px-5 pb-section-lg xl:px-0">
                    <div
                        className="subjectWrap relative m-auto flex max-w-7xl flex-col
                    items-stretch justify-center gap-5 rounded-[15px] sm:py-6
                    md:flex-row"
                    >
                        <div
                            className="left_conBox h-[240px] w-full rounded-[1rem] bg-[url('/public/img/subject_img.svg')]
                        bg-[position:50%_40%] bg-cover bg-no-repeat pl-7 pt-12
                        md:h-auto md:w-[560px] md:bg-left-top"
                        >
                            <h1 className="text-h1 font-bold text-white">
                                이런 분들에게
                                <br />
                                필요합니다
                            </h1>
                        </div>

                        <div className="right_conBox flex h-full w-full flex-col justify-between gap-5">
                            {Subject.map((list, idx) => (
                                <div
                                    key={list.id || idx}
                                    className="introConBox flex min-h-[230px] w-full
                                flex-col gap-3 rounded-[1rem] bg-[#F7F7F7] px-6 py-4 md:flex-row md:flex-nowrap md:gap-0"
                                >
                                    <h2
                                        className="w-full whitespace-nowrap pt-4
                                    text-h2 font-bold text-brand md:w-[30%]"
                                    >
                                        {renderWithLineBreaks(list.title)}
                                    </h2>
                                    <div className="subjectDetail flex w-full flex-row flex-wrap justify-end">
                                        {[
                                            list.detail_01,
                                            list.detail_02,
                                            list.detail_03,
                                            list.detail_04
                                        ].map((detail, i) => (
                                            <p
                                                key={i}
                                                className={`w-full border-b border-gray-300 py-3 text-body font-light last:border-b-0 xl:w-1/2 xl:px-6 ${ i % 2 === 0 ? "xl:border-r" : "" } ${i >= 2 ? "xl:border-b-0" : ""}`}
                                            >
                                                {renderWithLineBreaks(detail)}
                                            </p>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default FeatureDreamfactory;